// What a typed website address must be before we send it anywhere: the scheme is optional
// (https is assumed, as auth/input.ts assumes it server-side), the rest has to parse as
// an http(s) URL whose host has a dot — `www.google.com` passes, `google` and `ftp://x.y` don't.

/** The typed address as a URL string, or null when it is not a website address. */
export function siteUrl(text: string): string | null {
  const t = text.trim();
  if (t === "" || /\s/.test(t)) return null;
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(t) ? t : `https://${t}`;
  let url: URL;
  try {
    url = new URL(withScheme);
  } catch {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  if (!url.hostname.includes(".")) return null;
  return url.toString();
}

export const SITE_URL_HINT = "Enter a website address, like yourwebsite.com";
